class ExtrasListController {

    constructor($scope, $state, extrasService, messageService, access, $stateParams) {
        this.$scope = $scope;
        this.$state = $state;
        this.extrasService = extrasService;
        this.messageService = messageService;
        this.access = access;
        this.$stateParams = $stateParams;
    }

    $onInit () {
        this.filtertext = this.$stateParams.filtertext || null;

        if (this.filtertext) {
            this.isFiltered = true;
        }

        this.updatePaging();
        this.$scope.$watch(
            function (scope) {
                return scope.current_page;
            },
            function (newVal, oldVal, scope) {
                if (newVal !== oldVal) {
                    if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
                        scope.$ctrl.extras = undefined;
                        scope.$ctrl.extrasService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(response => {
                            scope.$ctrl.extras = response;
                            scope.$ctrl.loading = false;
                        });
                    }
                    else {
                        scope.$ctrl.extrasService.findAll(newVal, scope.per_page)
                            .then(list => scope.$ctrl.extras = list);
                    }
                }
            }
        );
    }

    onDelete (extra) {
        this.extrasService.delete(extra.id)
            .then(() => {
                this.messageService.success(`The extra <strong>${extra.name}</strong> was successfully deleted.`);
                this.messageService.push();
            })
            .catch((error) => {
                this.messageService.failure(`The extra <strong>${extra.name}</strong> could not be successfully deleted: ${error.statusText}`);
                this.messageService.push();
            })
            .then(() => {
                let page = this.extras.current_page;
                this.extras = [];
                this.loading = true;
                return this.extrasService.findAll(page).then(response => {
                    this.extras = response;
                    this.loading = false;
                });
            });
    }

    updatePaging () {
        this.$scope.per_page = this.extras.per_page;
        this.$scope.current_page = this.extras.current_page;
        this.$scope.total = this.extras.total;
    }

    filter () {
        if (!this.loading && this.filtertext) {
            this.startFilter();
            this.extrasService.search(this.filtertype, this.filtertext).then(response => {
                this.isFiltered = true;
                this.endFilter(response);
            });
        }
    }

    clearfilter () {
        if (this.isFiltered) {
            this.startFilter();
            this.extrasService.findAll(1, 20).then(response => {
                this.isFiltered = false;
                this.endFilter(response);
            });
        }
    }

    filtertypeChange () {
        switch (this.filtertype) {
            case 'featured':
            case 'status':
                this.filtertext = '1';
                break;
            default:
                this.filtertext = '';
                break;
        }
    }

    startFilter () {
        this.extras = undefined;
        this.loading = true;
    }

    endFilter (response) {
        this.extras = response;
        this.updatePaging();
        this.loading = false;
    }
}

ExtrasListController.$inject = ['$scope', '$state', 'extrasService', 'messageService', 'access', '$stateParams'];

export default ExtrasListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/extras.list.controller.js